
<div class="rtl flex flex-wrap mt-8">
  <div class="w-full">
    <div class="flex justify-center">
      <img src="../../../../assets/img/Ostadvisit-Logo-Color.svg" class="max-w-210-px opacity-80" alt="">
      
   </div>
  </div>
  <div class="w-full mb-8">
    <div class="flex justify-center">
      <h1 class="text-blueGray-600 text-3xl font-bold"> پنل مدیریت استاد ویزیت </h1>
      
   </div>
  </div>
  <div class="w-full lg:w-3/12 xl:w-3/12 p-4">
    <div class="flex-auto p-4 bg-primary rounded shadow-lg">
      <div class="flex flex-wrap">
        <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
          <h5 class="text-blueGray-100 uppercase font-bold text-xs">
            <!-- statSubtitle -->
          </h5>
          <span class="font-semibold text-lg text-white">
            تعداد پزشکان
          </span>
        </div>
        <div class="relative w-auto pl-4 flex-initial">
          <div
            class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full">
            <img src="../../../../assets/img/icon/people.svg" alt="">
          </div>
        </div>
      </div>
      <p class="text-sm text-blueGray-100 mt-4">
        <span class="whitespace-nowrap font-semibold text-xl text-white"> {{dashboardData.doctorCount}} </span>
      </p>
    </div>
  </div>

  <div class="w-full lg:w-3/12 xl:w-3/12 p-4">
    <div class="flex-auto p-4 bg-purple-500 rounded shadow-lg">
      <div class="flex flex-wrap">
        <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
          <h5 class="text-blueGray-100 uppercase font-bold text-xs">
            <!-- statSubtitle -->
          </h5>
          <span class="font-semibold text-lg text-white">
            تعداد بیماران
          </span>
        </div>
        <div class="relative w-auto pl-4 flex-initial">
          <div
            class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full">
            <img src="../../../../assets/img/icon/profile-2user.svg" alt="">
          </div>
        </div>
      </div>
      <p class="text-sm text-blueGray-100 mt-4">
        <!-- <span class="mr-2">
          <i class="fa fa-user" ></i>
          statPercent%
        </span> -->
        <span class="whitespace-nowrap font-semibold text-xl text-white"> {{dashboardData.userCount}} </span>
      </p>
    </div>
  </div>

  <div class="w-full lg:w-3/12 xl:w-3/12 p-4">
    <div class="flex-auto p-4 bg-blueGray-600 rounded shadow-lg">
      <div class="flex flex-wrap">
        <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
          <h5 class="text-blueGray-100 uppercase font-bold text-xs">
            <!-- statSubtitle -->
          </h5>
          <span class="font-semibold text-lg text-white">
           تعداد ویزیت ها
          </span>
        </div>
        <div class="relative w-auto pl-4 flex-initial">
          <div
            class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full">
            <img src="../../../../assets/img/icon/clipboard-text.svg" alt="">
          </div>
        </div>
      </div>
      <p class="text-sm text-blueGray-100 mt-4">
        <!-- <span class="mr-2">
        <i class="fa fa-user" ></i>
        statPercent%
      </span> -->
        <span class="whitespace-nowrap font-semibold text-xl text-white"> {{dashboardData.visitCount}} ویزیت</span>
      </p>
    </div>
  </div>

  <div class="w-full lg:w-3/12 xl:w-3/12 p-4">
    <div class="flex-auto p-4 bg-pink-500 rounded shadow-lg">
      <div class="flex flex-wrap">
        <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
          <h5 class="text-blueGray-100 uppercase font-bold text-xs">
            <!-- statSubtitle -->
          </h5>
          <span class="font-semibold text-lg text-white">
            موجودی کاربران
          </span>
        </div>
        <div class="relative w-auto pl-4 flex-initial">
          <div
            class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full">
            <img src="../../../../assets/img/icon/wallet-money.svg" alt="">
          </div>
        </div>
      </div>
      <p class="text-sm text-blueGray-100 mt-4">
        <!-- <span class="mr-2">
        <i class="fa fa-user" ></i>
        statPercent%
      </span> -->
        <span class="whitespace-nowrap font-semibold text-xl text-white"> {{dashboardData.userWalletAmount|number:''}} </span>
      </p>
    </div>
  </div>

  <div class="w-full lg:w-3/12 xl:w-3/12 p-4">
    <div class="flex-auto p-4 bg-teal-500 rounded shadow-lg">
      <div class="flex flex-wrap">
        <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
          <h5 class="text-blueGray-100 uppercase font-bold text-xs">
            <!-- statSubtitle -->
          </h5>
          <span class="font-semibold text-lg text-white">
          جمع تراکنشات
          </span>
        </div>
        <div class="relative w-auto pl-4 flex-initial">
          <div
            class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full">
            <img src="../../../../../assets/img/icon/menu-board.svg" alt="">
          </div>
        </div>
      </div>
      <p class="text-sm text-blueGray-100 mt-4">
        <!-- <span class="mr-2">
        <i class="fa fa-user" ></i>
        statPercent%
      </span> -->
        <span class="whitespace-nowrap font-semibold text-xl text-white"> {{dashboardData.siteAmount|number:''}} تومان </span>
      </p>
    </div>
  </div>

  <div class="w-full lg:w-3/12 xl:w-3/12 p-4">
    <div class="flex-auto p-4 bg-emerald-500 rounded shadow-lg">
      <div class="flex flex-wrap">
        <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
          <h5 class="text-blueGray-100 uppercase font-bold text-xs">
            <!-- statSubtitle -->
          </h5>
          <span class="font-semibold text-lg text-white">
            موجودی سایت
          </span>
        </div>
        <div class="relative w-auto pl-4 flex-initial">
          <div
            class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full">
            <img src="../../../../../assets/img/icon/message-time.svg" alt="">
          </div>
        </div>
      </div>
      <p class="text-sm text-blueGray-100 mt-4">
        <!-- <span class="mr-2">
        <i class="fa fa-user" ></i>
        statPercent%
      </span> -->
        <span class="whitespace-nowrap font-semibold text-xl text-white"> {{dashboardData.siteWalletAmount|number:''}} تومان </span>
      </p>
    </div>
  </div>

  <div class="w-full lg:w-3/12 xl:w-3/12 p-4">
    <div class="flex-auto p-4 bg-yellow-500 rounded shadow-lg">
      <div class="flex flex-wrap">
        <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
          <h5 class="text-blueGray-100 uppercase font-bold text-xs">
            <!-- statSubtitle -->
          </h5>
          <span class="font-semibold text-lg text-white">
            برداشت
          </span>
        </div>
        <div class="relative w-auto pl-4 flex-initial">
          <div
            class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full">
            <img src="../../../../../assets/img/icon/wallet-money.svg" alt="">
          </div>
        </div>
      </div>
      <p class="text-sm text-blueGray-100 mt-4">
        <!-- <span class="mr-2">
          <i class="fa fa-user" ></i>
          statPercent%
        </span> -->
        <span class="whitespace-nowrap font-semibold text-xl text-white"> {{dashboardData.withdrawAmount| number:''}}
          تومان </span>
      </p>
    </div>
  </div>
  
  <div class="w-full lg:w-3/12 xl:w-3/12 p-4">
    <div class="flex-auto p-4 bg-lightBlue-500 rounded shadow-lg">
      <div class="flex flex-wrap">
        <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
          <h5 class="text-blueGray-100 uppercase font-bold text-xs">
            <!-- statSubtitle -->
          </h5>
          <span class="font-semibold text-lg text-white">
            موجودی پزشکان
          </span>
        </div>
        <div class="relative w-auto pl-4 flex-initial">
          <div
            class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full">
            <img src="../../../../assets/img/icon/wallet-money.svg" alt="">
          </div>
        </div>
      </div>
      <p class="text-sm text-blueGray-100 mt-4">
        <span class="whitespace-nowrap font-semibold text-xl text-white"> {{dashboardData.doctorWalletAmount| number:''}}
          تومان </span>
      </p>
    </div>
  </div>



</div>